import React from "react";
import { Button } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import Posts from "../Components/Posts";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import Logged from "../Components/Profile.jsx";
import axios from "axios";
import { url } from "../utils/url";
import EmptyPost from "../Components/EmptyPost";
import SEO from "../Components/SEO";
import SidebarNav from "../Components/navigation/SidebarNav";

function SingleUser() {
  const { mode } = React.useContext(UserContext);
  const [dark, setDark] = React.useState(false);

  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  const [posts, setposts] = React.useState([]);
  const [currentuser, setcurrentuser] = React.useState({});
  const { user, posts: statePosts } = React.useContext(UserContext);
  const { id, username } = useParams();
  React.useEffect(() => {
    // const tempPosts = statePosts.filter((item) => item.user_id === id);
    // setposts(tempPosts);

    async function loadUser() {
      // await axios.get(`${url}/api/auth/profile/${id}`).then((res) => {
      await axios
        .get(`${url}/api/auth/profile-username/${username}`, {
          headers: {
            Authorization: "Bearer " + user?.token,
          },
        })
        .then((res) => {
          setcurrentuser(res.data.data);
        });
      await axios
        .get(`${url}/api/posts/getposts/user/${currentuser._id}`)
        .then((res) => {
          setposts(res.data.data);
        });
    }
    loadUser();
  }, [id, username, statePosts, user?.token, currentuser._id]);
  const history = useHistory();
  if (!user.token) {
    history.push("/login");
  }

  let displayPosts = posts.filter((p) => p.author?._id === currentuser?._id);
  return (
    <>
      <SEO title={`${currentuser?.username}`}></SEO>
      <div className="flex justify-center w-full">
      <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
      <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
              <SidebarNav />
              </div>
            </div>
            <div className="col-span-6">
            {user.token ? (
              displayPosts.length > 0 ? (
                displayPosts.map((post) => {
                  return <Posts key={post._id} data={post} />;
                })
              ) : (
                <EmptyPost dark={dark} />
              )
            ) : (
              <div>
                {displayPosts.length > 0 ? (
                  <Posts data={displayPosts[0]} />
                ) : (
                  <EmptyPost dark={dark} />
                )}
                <Link to="/login" className="readMore__link">
                  <Button className="mb-3 bg-fire text-white rounded px-3   hover:opacity-80 hover:text-white">
                    View More
                  </Button>
                </Link>
              </div>
            )}
          </div>
          </div>
          <div className="lg:col-span-5">
            {user.token ? (
              <Logged currentuser={currentuser} count={displayPosts.length} />
            ) : (
              <TryLogin />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleUser;